import { Link } from 'react-router-dom';

function NewQuoteInfo({
  newQuote, discounted_amount, fastQuoteId, setShowGreeniaAI, companies,
}) {
  return (
    <div className="w-75 ms-auto mb-3">
      <div className="bg-success border border-success p-3 rounded-3 shadow">
        <h5 className="fs-6 text-white">Nuovo Preventivo</h5>
        <hr />
        <div>
          <div>
            <div className="row">
              {newQuote.brand && (
                <div className="col-6">
                  <p className="m-0 text-white">
                    <small>
                      <strong>
                        Marca:
                      </strong>
                      {' '}
                      {newQuote.brand}
                    </small>
                  </p>
                </div>
              )}
              {newQuote.model && (
                <div className="col-6">
                  <p className="m-0 text-white">
                    <small>
                      <strong>
                        Modello:
                      </strong>
                      {' '}
                      {newQuote.model}
                    </small>
                  </p>
                </div>
              )}
              {newQuote.vehicleId && (
                <div className="col-6">
                  <p className="m-0 text-white">
                    <small>
                      <strong>
                        Targa:
                      </strong>
                      {' '}
                      {newQuote.vehicleId.toUpperCase()}
                    </small>
                  </p>
                </div>
              )}
              {newQuote.servizi !== null && (
                <div className="col-6">
                  <p className="m-0 text-white">
                    <small>
                      <strong>
                        Servizi:
                      </strong>
                      {' '}
                      {newQuote.servizi}
                      {' '}
                      €
                    </small>
                  </p>
                </div>
              )}
              {newQuote.tasse_totali && (
                <div className="col-6">
                  <p className="m-0 text-white">
                    <small>
                      <strong>
                        Tasse Totali:
                      </strong>
                      {' '}
                      {newQuote.tasse_totali}
                      {' '}
                      €
                    </small>
                  </p>
                </div>
              )}
              {newQuote.da_pagare && (
                <div className="col-6">
                  <p className="m-0 text-white">
                    <small>
                      <strong>
                        Premio Totale:
                      </strong>
                      {' '}
                      {newQuote.da_pagare}
                      {' '}
                      €
                    </small>
                  </p>
                </div>
              )}
              {discounted_amount && (
                <div className="col-6">
                  <p className="m-0 text-white">
                    <small>
                      <strong>
                        Premio Scontato:
                      </strong>
                      {' '}
                      {discounted_amount}
                      {' '}
                      €
                    </small>
                  </p>
                </div>
              )}
            </div>
            <hr />
            {companies && companies.length > 0 && (
              <>
                <p className="m-0 text-white mb-1">
                  <small>
                    <strong>Altre compagnie:</strong>
                  </small>
                </p>
                {[...companies]
                  .sort((a, b) => a.amount - b.amount)
                  .map((c, index) => (
                    <p key={`${c.company}-${index}`} className="m-0 text-white">
                      <small>{`• ${c.company}: ${Number(c.amount).toFixed(2)} €`}</small>
                    </p>
                  ))}
                <hr />
              </>
            )}
            <div className="row mt-2">
              <div className="col-12">
                <Link
                  onClick={() => setShowGreeniaAI(false)}
                  className="btn btn-light"
                  to={`/quote/auto/${fastQuoteId}`}
                >
                  Procedi con il Preventivo
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NewQuoteInfo;
